module.exports = __webpack_public_path__ + "media/mâi kâo jai loie pûak tân bpen yang ngai.7ab4b4a7.mp3";